<template>
    <div>
        <b-row>
            <b-col>
                <span class="t-title">
                    LOGIN - Timpel TTS
                </span>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <b-form-input id="tts-login" @keyup.enter="login" v-model="email" placeholder="E-mail" />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-form-input id="tts-password" @keyup.enter="login" v-model="password" type="password"
                    :placeholder="$t('Password')" />
            </b-col>
        </b-row>
        <b-row v-if="message">
            <b-col>
                <small class="text-danger">
                    {{ message }}
                </small>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span class="t-link" @click="$parent.forgot_password = true">
                    {{ $t('Forgot the password') }}
                </span>
            </b-col>
        </b-row>
        <br>
        <b-row class="mt-3">
            <b-col>
                <b-button @click="login" class="bg-t-blue login-form-button" block variant="primary">
                    {{ $t("Login") }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            email: '',
            message: ''
        }
    },
    mounted() {
        if (process.env.VUE_APP_AUTO_LOGIN === 'true') {
            const autoEmail = process.env.VUE_APP_DEV_LOGIN_EMAIL || ''
            const autoPassword = process.env.VUE_APP_DEV_LOGIN_PASSWORD || ''

            if (autoEmail && autoPassword) {
                this.email = autoEmail
                this.password = autoPassword
                this.login()
            }
        }
    },
    methods: {
        login() {
            this.$utils.request(
                "login/",
                "POST",
                {
                    email: this.email,
                    password: this.password
                },
                (r) => {
                    console.log(r)
                    localStorage.setItem(
                        'access',
                        r.data.access
                    )
                    localStorage.setItem(
                        'refresh',
                        r.data.refresh
                    )
                    this.$store.commit('set_logged', true)
                    this.$router.push('/equipment-list').catch(() => {})
                },
                (r) => {
                    this.$utils.customAlert(
                        this.$t('Invalid e-mail or password.'),
                        'd'
                    )
                }
            )
        }
    }
}
</script>

<style></style>
